import type { ProductInformationViewModel } from 'autogen/swagger/all';
import InlineButton from 'components/generic/InlineButton';
import format from 'helpers/translations';
import { useProductDeliveryInfoViewModelQuery } from 'autogen/swagger/all/hooks';
import { useProductPageExpectedDeliveryQuickView } from 'components/expecteddelivery/shared/hooks/useProductPageExpectedDeliveryQuickView';
import { GA4Tracking } from 'modules/tracking/GA4';

export default function ExpectedDelivery(props: ProductInformationViewModel) {
    const { expectedDelivery, productId } = props;
    const toggle = useProductPageExpectedDeliveryQuickView();

    const { data: deliveryInfo } = useProductDeliveryInfoViewModelQuery(
        { productId },
        { initialData: expectedDelivery?.deliveryInfo, refetchOnMount: false }
    );

    function tracking() {
        GA4Tracking({
            eventName: 'open_modal',
            category: 'ecommerce',
            context: 'product_page',
            eventParams: [{ param_name: 'modal_type', param_value: 'delivery_info' }]
        });
    }

    return (
        <div>
            {deliveryInfo &&
                format(
                    deliveryInfo.mainText,
                    deliveryInfo.buttonText && (
                        <InlineButton
                            onClick={() => {
                                toggle(true);
                                tracking();
                            }}
                        >
                            {deliveryInfo.buttonText}
                        </InlineButton>
                    )
                )}
        </div>
    );
}
